module.exports = __webpack_public_path__ + "static/media/TissuePaper.a9087937.wav";